import { Close } from '@mui/icons-material';
import { Drawer, IconButton } from '@mui/material';
import { Box, Stack } from '@mui/system';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const VersionsDrawer = ({ open, onClose, data }) => {
  const { t, i18n } = useTranslation('translations');
  const lang = i18n.language;

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: { md: 400, xs: 343 } }} role="presentation">
        <div className="flex gap-10 items-center pt-16 pl-3">
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
          <h4 className=" text-xl text-[#16151c] dark:text-white">{t('DocumentInformation')}</h4>
        </div>
        <Stack spacing={1} sx={{ padding: '16px' }}>
          <div>
            <div className="text-10 text-grey">{t('Title')}</div>
            <div>{lang == 'uz' ? data?.titleUz : data?.titleRu || '-'}</div>
          </div>
          <div>
            <div className="text-10 text-grey">{t('Description')}</div>
            <div>{lang == 'uz' ? data?.descriptionUz : data?.descriptionRu || '-'}</div>
          </div>
          <div>
            <div className="text-10 text-grey">{t('Creator')}</div>
            <div>{data?.creatorInfo?.creator?.name || '-'}</div>
          </div>
          <div>
            <div className="text-10 text-grey">{t('CreatedDate')}</div>
            <div>
              {data?.createdDate ? moment(data?.createdDate).format('DD.MM.YYYY HH:mm:ss') : '-'}
            </div>
          </div>
        </Stack>
      </Box>
    </Drawer>
  );
};

export default VersionsDrawer;
